import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  getCookieConsent,
  postCookieConsent,
} from 'src/app/modules/auth/cookie-consent/api'
import type {CookieConsent} from 'src/app/modules/auth/cookie-consent/types'

export const fetchCookieConsent = createAsyncThunk('cookieConsent/fetchCookieConsent', async (_, toolkit) => {
  return await getCookieConsent(toolkit)
})

export const saveCookieConsent = createAsyncThunk(
  'cookieConsent/saveCookieConsent',
  async (payload: CookieConsent, toolkit) => {
    return await postCookieConsent(payload, toolkit)
  }
)
